import * as React from "react";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import {LabelableProps} from "../../common/props/LabelableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {option} from "ts-option";
import {TierLevel} from "../../../model/asset/Asset";

type Props = FormGroupProps<TierLevel> & PlaceholderProps & LabelableProps

export default class TierLeverFormGroup extends React.Component<Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label}
					   error={this.props.field.firstError().orNull}
					   customClass={"c-tier-level-form-group"}>
				<DropDown items={Object.keys(TierLevel)}
						  itemToLabel={(item: any) => TierLevel[item].capitalize()}
						  itemToId={(item: string) => item}
						  onSelect={this.onChange}
						  selectedItemId={this.props.field.getOptionalValue().orNull}
						  placeholder={this.props.placeholder}/>
			</FormGroup>
		)
	}

	onChange = (item: any) => {
		this.props.onChange(this.props.field.updateValue(option(TierLevel[item] as TierLevel)));
	}
}